/**
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { FileAction } from '@nextcloud/files';
import { translate as t } from '@nextcloud/l10n';
import CalendarClockSvg from '@mdi/svg/svg/calendar-clock.svg?raw';
import { SET_REMINDER_MENU_ID } from './setReminderMenuAction';
import { pickCustomDate } from '../services/customPicker';
export const action = new FileAction({
    id: 'set-reminder-custom',
    displayName: () => t('files_reminders', 'Custom reminder'),
    title: () => t('files_reminders', 'Reminder at custom date & time'),
    iconSvgInline: () => CalendarClockSvg,
    enabled: (nodes, view) => {
        if (view.id === 'trashbin') {
            return false;
        }
        // Only allow on a single node
        if (nodes.length !== 1) {
            return false;
        }
        const node = nodes.at(0);
        const dueDate = node.attributes['reminder-due-date'];
        return dueDate !== undefined;
    },
    parent: SET_REMINDER_MENU_ID,
    async exec(file) {
        pickCustomDate(file);
        return null;
    },
    // After presets
    order: 22,
});
